import {combineReducers, configureStore} from "@reduxjs/toolkit";
import appReducer, {name as appReducerName} from "./slices/app";
import addToCartReducer, {name as addToCartName} from "./slices/addToCart";
import reviewMediaReducer, {name as reviewMediaName} from "./slices/reviewMediaPagination";
import ratingPaginationReducer, {name as ratingPaginationName} from "./slices/ratingPagination";
import accordionReducer, {name as accordionName} from "./slices/accordion";
import listItemTransactionReducer, {name as listItemTransactionName} from "./slices/listItemTransaction";
import artworkOffCanvasReducer, {name as artworkOffCanvasName} from "./slices/artworkOffCanvas";
import cartReducer, {name as cartName} from "./slices/carts";
import mediaGalleryReducer, {name as mediaGalleryName} from "./slices/mediaGallery";

const rootReducer = combineReducers({
    [accordionName]: accordionReducer,
    [addToCartName]: addToCartReducer,
    [appReducerName]: appReducer,
    [artworkOffCanvasName]: artworkOffCanvasReducer,
    [cartName]: cartReducer,
    [listItemTransactionName]: listItemTransactionReducer,
    [mediaGalleryName]: mediaGalleryReducer,
    [ratingPaginationName]: ratingPaginationReducer,
    [reviewMediaName]: reviewMediaReducer
});

export const store = configureStore({
    reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;